var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23305F",
    d: "M2.02 23q-.864 0-1.442-.578Q0 21.843 0 20.98V5.019q0-.863.578-1.44Q1.157 3 2.02 3h10.484l-1.25 1.25H2.018q-.288 0-.529.24-.24.24-.24.53v15.96q0 .29.24.53t.53.24h15.96q.29 0 .53-.24t.24-.53v-9.36L20 10.37v10.61q0 .864-.578 1.442-.579.578-1.441.578zm5.48-7.5v-3.27L18.68 1.05q.207-.206.435-.286a1.46 1.46 0 0 1 .942 0q.224.079.407.263l1.39 1.348q.198.207.302.456t.104.5q0 .254-.076.478-.076.225-.282.431L10.649 15.5zm1.25-1.25h1.365l8.332-8.332-.683-.682-.761-.731-8.253 8.252z"
  })));
};
export default SvgEdit;